import { format } from "date-fns";

import { convertToDate } from "./convertToDate";

export const localizeDateString = (dateToFormat: string | number): string => {
  const date = convertToDate(dateToFormat);
  return format(date, "dd.MM.yyyy kk:mm");
};
